import adUser from './ad-user';
import populationModel from 'modules/population/model';
import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';

const Store = {
    adUser,
    populationModel,
};

export default Store;

export function useMobxStore() {
    const models: Partial<typeof Store> = useContext(MobXProviderContext);
    return models;
}
